






















































import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import HeaderInfo from '@/components/App/Modules/GMS/Grants/ExpansionPanel/ExpansionPanel.vue';
import FileUpload from "@/components/common/Inputs/FileUpload.vue";
import FileDownload from "@/components/common/fileDownload/fileDownload.vue";
import DateComponent from "@/components/common/Inputs/Date.vue";
import WorkflowButtons from '@/components/common/ProgressBar/WorkflowButtons.vue';
import { GrantData, GrantAmendmentData } from "@/entities";
const namespace: string = "grantAmendment";

@Component({
  components: {
    HeaderInfo,
    FileUpload,
    FileDownload,
    DateComponent,
    WorkflowButtons
  }
})
export default class GrantAmendmentSignComponent extends Vue {
  @Prop() GrantInfo: any;
  @Prop() readOnly: boolean;
  @Prop() docTags!: any;
  @Prop() modelWrapper: any;
  @Prop() workFlowItems: any;
  @Prop() grantAmendment: any;
  @Action("uploadDocument", { namespace }) uploadDocument: any;
  files: any = [{}];
  grantAmendmentDocsKey: number = 1;

  /** Get the grant activity log */
  mounted() {
    this.addEmptyRow();
  }

  get grantAmendmentDocs() {
    if (this.modelWrapper.agreementDocuments) {
      return this.modelWrapper.agreementDocuments;
    } else {
      this.modelWrapper.agreementDocuments = [{}];
      return this.modelWrapper.agreementDocuments
    }
  }

  onAddFiles(e, doc) {
    const { name, type, size } = e;
    this.uploadDocument({
      file: e,
      schema: {
        options: {
          docTag: doc.docType,
          menu: _app.menu.grantAmendment
        },
      },
      transactionId: this.grantAmendment.grantAmendment.GrantAmendmentId,
      language: this.$vuetify.lang.current,
    }).then((data) => {
      Object.assign(doc, data, { name, type, size });
      this.$emit('SetDirty');
      this.$emit("updateData", doc);
      this.addEmptyRow();
    });
  }

  onRemoveFile(index, doc) {
    this.$services.document.removeDocument(doc)
      .then((data) => {
        this.grantAmendmentDocs.splice(index, 1);
        this.$emit('SetDirty');
        this.$emit('updateData', doc);
        this.addEmptyRow();
      })
  }

  addEmptyRow() {
    if (this.grantAmendmentDocs) {
      const emptyRow = this.grantAmendmentDocs.find(x => Object.keys(x).length === 0);
      if (!emptyRow) {
        this.grantAmendmentDocs.push({});
      }
    }
    this.grantAmendmentDocsKey += 1;
  }

  updateDate(val) {
    this.modelWrapper.AgreementDate = val;
    this.$emit('SetDirty', val);
  }

  showValidation(msgs: any) {
    this.grantAmendment.validationMessages = msgs;
    this.grantAmendment.showValidationDilog = true;
  }
}
